export default "__VITE_ASSET__BOteX4_b__"